import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, useCallback } from 'react';
import { RobotContext } from './RobotContext';
import { getAllAssetPaths, preloadImages } from './utils';
export function RobotProvider({ mode, targetElementId, assetsBasePath, onRobotClick, waveConfig = { minIdleMs: 10000, maxIdleMs: 30000 }, walkConfig, children, }) {
    const [images, setImages] = useState(new Map());
    const [imagesLoaded, setImagesLoaded] = useState(false);
    const [currentState, setCurrentState] = useState(mode === 'bottom-bar' ? 'bottomBarAuto' : 'standing');
    const setState = useCallback((state) => {
        setCurrentState(state);
    }, []);
    useEffect(() => {
        if (mode === 'inline' && !targetElementId) {
            console.warn('RobotProvider: targetElementId is required when mode is "inline"');
        }
    }, [mode, targetElementId]);
    useEffect(() => {
        setImagesLoaded(false);
        const assetPaths = getAllAssetPaths(assetsBasePath, mode);
        preloadImages(assetPaths, (loadedImages) => {
            setImages(loadedImages);
            setImagesLoaded(true);
        });
    }, [assetsBasePath, mode]);
    const contextValue = {
        mode,
        targetElementId,
        assetsBasePath,
        onRobotClick,
        waveConfig,
        walkConfig,
        images,
        imagesLoaded,
        setState,
        currentState,
    };
    return (_jsx(RobotContext.Provider, { value: contextValue, children: children }));
}
